import type { DirectiveBinding } from 'vue';

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding<() => void>) {
    const callback = binding.value;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        callback();
        observer.disconnect();
      }
    }, {
      threshold: 0.5
    });

    observer.observe(el);
    (el as any).__observer__ = observer;
  },

  unmounted(el: HTMLElement) {
    const observer = (el as any).__observer__;
    if (observer) observer.disconnect();
  }
};
